<template>
	<div>
		<div class="singleTitle">
			<h3>联系我们</h3>
		</div>
		<div class="mainLayout">
			<div id="container" class="mapBox">
				<img src="../../assets/szditu.png" alt="公司地图" class="map-img" />
			</div>
			<div class="lxText">
				<div>
					<span>
						<i class="el-icon-map-location"></i>
						<h3>地址</h3>
					</span>
					<p>{{aboutDetail.address}}</p>
				</div>
				<div>
					<span>
						<i class="el-icon-phone-outline
"></i>
						<h3>电话</h3>
					</span>
					<p>{{aboutDetail.phone}}</p>
				</div>
				<div>
					<span>
						<i class="el-icon-message"></i>
						<h3>邮箱</h3>
					</span>
					<p>{{aboutDetail.email}}</p>
				</div>
			</div>

		</div>
	</div>
</template>
<script>
	import AMapLoader from '@amap/amap-jsapi-loader';
	export default {
		name: "mapDemo",
		data() {
			return {
				//联系我们
				aboutDetail: Object
			};
		},
		mounted() {
			//联系我们
			this.usDetail();
			//DOM初始化完成进行地图初始化
			/* this.initMap(); */
		},
		methods: {
			usDetail() {
				this.$axios.get("/api/us/1").then((response) => {
					this.aboutDetail = response.data.data;
					console.log(response.data.data);
				});
			},
			//地图初始化函数 initMap
		},
	};
</script>
<!-- 可选：给图片加样式 -->
<style scoped>
	.map-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		/* 保持图片比例 */
		display: block;
	}
</style>